import {
  Group,
  Badge,
  Stack,
  ThemeIcon,
  Divider,
  Button,
  Text,
  Box,
} from "@mantine/core";
import { IconDots, IconFlag } from "@tabler/icons-react";
import { useBoard } from "../../common/boards/board.hooks";
import { Swords } from "../../common/icons/swords";
import { Match } from "../../common/matches/match.schema";
import { Member } from "../../common/members/member.schema";
import { useAuthStore } from "../../common/stores/auth.store";
import { useIsEventReferee } from "../../common/events/event.hooks";
import {
  EliminationMatchup,
  Elimination,
  Event,
} from "../../common/events/event.schema";
import MemberDisplay from "../members/MemberDisplay";
import { getHasTeams } from "./util";

const MatchupDisplay = ({
  matchup,
  event,
  elimination,
  openMatch,
  matchupIndex,
  disabled,
}: {
  matchup: EliminationMatchup;
  event: Event;
  elimination: Elimination;
  openMatch: (matchup: EliminationMatchup) => void;
  matchupIndex: number;
  disabled?: boolean;
}) => {
  const isRef = useIsEventReferee();
  const { board } = useBoard();

  const members = getHasTeams(event)
    ? (event.teams as Member[])
    : (event.members as Member[]);
  // const { matches } = useMatches({ eventId: event._id });
  const matches = event.matches as Match[];
  // if (!matchup) return <Text size="xs">?x</Text>;
  const match = matches.find((m) => m._id === matchup.match);
  let a = matchup?.members && members.find((m) => m._id === matchup.members[0]);
  let b = matchup?.members && members.find((m) => m._id === matchup.members[1]);
  const user = useAuthStore((s) => s.user);
  const playoff = matchup.playoff;

  const eliminationIndex = event.eliminations.indexOf(elimination);
  // console.log("eliminationIndex :", eliminationIndex);
  // console.log("elimination :", elimination);
  // const matchupIndex = elimination.matchups.indexOf(matchup);
  // console.log("matchupIndex :", matchupIndex);
  const aPrevIndex = matchupIndex * 2;
  const bPrevIndex = aPrevIndex + 1;
  const prevElimination = event.eliminations[eliminationIndex - 1];
  // console.log("prevElimination :", prevElimination);
  // console.log("matchup", matchup);
  // return <p>a:{matchupIndex}</p>;
  if (!a && elimination.round > 1) {
    const aPrevMatchup = prevElimination.matchups[aPrevIndex];
    if (aPrevMatchup?.complete) {
      // console.log("aPrevMatchup :", aPrevMatchup);
      // console.log("playoff :", playoff);
      const prevWinner = aPrevMatchup.winner;
      // console.log("prevWinner :", prevWinner);
      const prevLoser = aPrevMatchup.members.find((m) => m !== prevWinner);
      // console.log("prevLoser :", prevLoser);
      a = members.find((m) => m._id === (playoff ? prevLoser : prevWinner));
      // console.log("a :", a);
    }
  }
  // console.log("a :", a);
  if (!b && elimination.round > 1) {
    const bPrevMatchup = prevElimination.matchups[bPrevIndex];
    if (bPrevMatchup?.complete) {
      // console.log("aPrevMatchup :", aPrevMatchup);
      const prevWinner = bPrevMatchup.winner;
      const prevLoser = bPrevMatchup.members.find((m) => m !== prevWinner);
      b = members.find((m) => m._id === (playoff ? prevLoser : prevWinner));
      // console.log("a :", a);
    }
  }
  // console.log("b :", b);
  const tbd = (!a || !b) && !matchup.bye;
  const isSelf = (user && a?.user === user._id) || b?.user === user?._id;
  const selfEnabled = isSelf && board?.ownMatches;
  const enabled =
    user &&
    (selfEnabled || isRef) &&
    !matchup.complete &&
    !matchup.bye &&
    !tbd &&
    !disabled;
  let aPoints = match?.winnerPoints;
  let bPoints = match?.loserPoints;
  if (matchup.winner === b?._id) {
    aPoints = match?.loserPoints;
    bPoints = match?.winnerPoints;
  }
  const final = !matchup.playoff && elimination.size === 2;
  // console.log("a :", a);
  // return <p>a:{a?._id}</p>;
  return (
    <Group justify="center">
      {final && (
        <Box pos="absolute" left={15}>
          <Badge variant="light" size="xs" color="yellow">
            Final
          </Badge>
        </Box>
      )}
      {playoff && (
        <Box pos="absolute" left={15}>
          <Badge variant="light" size="xs" color="orange">
            Third
          </Badge>
        </Box>
      )}

      <Stack gap={7}>
        {!a && <Text size="xs">?</Text>}
        {a && (
          <Group justify="center">
            <MemberDisplay avatar size="sm" member={a} max={15} />
            {match && (
              <ThemeIcon
                size="sm"
                variant="light"
                color={matchup.winner === a._id ? "green" : "red"}
              >
                <Text size="xs">{aPoints}</Text>
              </ThemeIcon>
            )}
            {b && matchup.winner === b._id && matchup.withdrawal && (
              <ThemeIcon variant="light" color="dark" size="xs">
                <IconFlag />
              </ThemeIcon>
            )}
          </Group>
        )}
        <Divider miw={50} />
        {b && (
          <Group justify="center">
            <MemberDisplay avatar size="sm" member={b} max={15} />
            {match && (
              <ThemeIcon
                size="sm"
                variant="light"
                color={matchup.winner === b._id ? "green" : "red"}
              >
                <Text size="xs">{bPoints}</Text>
              </ThemeIcon>
            )}
            {a && matchup.winner === a._id && matchup.withdrawal && (
              <ThemeIcon variant="light" color="dark" size="xs">
                <IconFlag />
              </ThemeIcon>
            )}
          </Group>
        )}
        {!b && !matchup.bye && <Text size="xs">?</Text>}
        {!b && matchup.bye && (
          <Text>
            <IconDots size={15} color="gray" />
          </Text>
        )}
      </Stack>

      {enabled && (
        <div style={{ position: "absolute", right: 0, top: 0, bottom: 0 }}>
          <Button
            size="xs"
            variant="filled"
            px={5}
            h={"100%"}
            style={{ borderRadius: "0 4px 4px 0" }}
            onClick={() => openMatch(matchup)}
          >
            <Swords />
            {/* Result */}
          </Button>
        </div>
      )}
    </Group>
  );
};
export default MatchupDisplay;
